export default __webpack_public_path__ + "static/media/savings-ratio-page.954ab2cc.svg";